/* ═══════════════════════════════════════════════
   ink.IA — Grilla de productos
   assets/ia-collection.js
   Filtros por categoría y agregar rápido al carrito.
   ═══════════════════════════════════════════════ */
 
(function () {
  'use strict';
 
  if (window.__iaCollectionLoaded) return;
  window.__iaCollectionLoaded = true;
 
  var root = document.querySelector('[data-ia-col]');
  if (!root) return;
 
  var cards = Array.prototype.slice.call(root.querySelectorAll('.ia-card'));
  var pills = Array.prototype.slice.call(root.querySelectorAll('[data-ia-filter]'));
  var count = root.querySelector('[data-ia-count]');
  var empty = root.querySelector('[data-ia-empty]');
 
  /* ── filtros ─────────────────────────────── */
  function aplicar(tag) {
    var visibles = 0;
 
    cards.forEach(function (c) {
      var tags = (c.dataset.tags || '').toLowerCase();
      var ok = tag === '*' || tags.split('|').indexOf(tag) !== -1;
      c.hidden = !ok;
      if (ok) visibles++;
    });
 
    pills.forEach(function (p) {
      p.setAttribute('aria-pressed', String(p.dataset.iaFilter === tag));
    });
 
    if (count) {
      count.textContent = visibles === 1 ? '1 producto' : visibles + ' productos';
    }
    if (empty) empty.hidden = visibles > 0;
  }
 
  pills.forEach(function (p) {
    p.addEventListener('click', function () { aplicar(p.dataset.iaFilter); });
  });
 
  /* ── agregar rápido ──────────────────────── */
  var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6"><path d="M20 6 9 17l-5-5"/></svg>';
 
  root.querySelectorAll('[data-ia-add]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
 
      var id = btn.dataset.iaAdd;
      if (!id || btn.disabled) return;
 
      var original = btn.innerHTML;
      btn.disabled = true;
      btn.textContent = 'Agregando…';
 
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () {
          btn.classList.add('is-done');
          btn.innerHTML = CHECK + '<span>Agregado</span>';
          actualizarCarrito();
          setTimeout(function () {
            btn.classList.remove('is-done');
            btn.innerHTML = original;
            btn.disabled = false;
          }, 2000);
        })
        .catch(function () {
          /* Si algo falla, mandamos a la ficha en vez de dejarlo sin respuesta */
          window.location.href = btn.dataset.iaUrl || '/cart';
        });
    });
  });
 
  /* Actualiza el número del carrito en el header sin recargar */
  function actualizarCarrito() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var badge = document.querySelector('.ia-hd__badge');
        var icon = document.querySelector('.ia-hd__ic[href*="cart"]');
 
        if (badge) {
          badge.textContent = cart.item_count;
        } else if (icon && cart.item_count > 0) {
          var s = document.createElement('span');
          s.className = 'ia-hd__badge';
          s.textContent = cart.item_count;
          icon.appendChild(s);
        }
        document.dispatchEvent(new CustomEvent('ink:cart', { detail: cart }));
      })
      .catch(function () {});
  }
})();